import BaseAuthLayout from '../../../components/base-auth-layout/base-auth-layout';
import SuccessSetting from '../../../components/success-setting/success-setting';
import { useSuccessSetting } from '../../store/slice/success-setting-slice';
import FormRegister from './form-register/form-register';

export type CallbackProps = {
  pathImage?: string | undefined;
};

const Register = ({ pathImage = '/assets/images/computer-register.svg' }: CallbackProps) => {
  const { dataSuccessSetting } = useSuccessSetting();

  return !dataSuccessSetting ? (
    <BaseAuthLayout
      leftChildren={<FormRegister />}
      rightChildren={
        <img
          src={pathImage}
          alt="Register illustration"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      }
    />
  ) : (
    <SuccessSetting {...dataSuccessSetting} />
  );
};

export default Register;
